import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../Base/Components/Loader/Loader";
import { useForm } from "../../../../Base/Hooks/useForm";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getUnidades } from "../../../../Base/API/Global/Unidades/UnidadesRequest";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarCosto, getAdditional, getAdditionalCost, getDyeCost, getKnitCost, getOtherCost } from "../../../../API/Ventas/Cotizaciones/CotizacionesRequest";
import { getDensity, getDyeType, getFabricStyles, getStyleCategory, getYarnTitle } from "../../../../API/Desarrollo/DesarrolloRequest";
import KnitCostCRUD from "../../Cotizaciones/CRUD/KnitCostCRUD";
import DyeCostCRUD from "../../Cotizaciones/CRUD/DyeCostCRUD";
import AdditionalCostCRUD from "../../Cotizaciones/CRUD/AdditionalCostCRUD";
import OthersCostCRUD from "../../Cotizaciones/CRUD/OthersCostCRUD";



const ModalAgregarDet = ({
  showDialog,
  setShowDialog,
  costosAdicionales,
  setCostosAdicionales,
  costosOtros,
  setCostosOtros,
  totalAdicional,
  setTotalAdicional,
  totalOtros,
  setTotalOtros,
  agregarNuevaFila,
  selected,
  setSelected,
  getInfo,
  setTotal,
  total,
  IdQuotation
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [styles, setStyles] = useState([]);
  const [yarn, setYarn] = useState([]);
  const [fabricStyle, setFabricStyle] = useState([]);
  const [dyeType, setDyeType] = useState([]);
  const [densidad, setDensidad] = useState([]);
  const [units, setUnits] = useState([]);
  const [Additional, setAdditional] = useState([]);
  const [AdditionalOtros, setAdditionalOtros] = useState([]);
  const [selectedAdd, setSelectedAdd] = useState([]);
  const [selectedOtros, setSelectedOtros] = useState([]);

  const [dialogKnit, setDialogKnit] = useState(false);
  const [dialogDye, setDialogDye] = useState(false);
  const [dialogAdd, setDialogAdd] = useState(false);
  const [dialogOther, setDialogOther] = useState(false);
  

  const initialValues = {
    IdQuotationDetail: -1,
    Date: new Date(),
    KnitCost: 0,
    DyeCost: 0,
    Cantidad: 0,
    PorcentageY1: 0,
    PorcentageY2: 0,
    PorcentageY3: 0,
    KnnittingLoss: 0,
    DyeLoss: 0,
  };

  const { values, setValues, handleInputChange, handleChange, resetForm, error, setError } = useForm(initialValues);

  const getInfo2 = async () => {
    setLoading(true);

    const IdQuotationDetail = selected?.IdQuotationDetail

    const stylesTempo = await getStyleCategory();
    setStyles(stylesTempo);

    const unitsTempo = await getUnidades();
    setUnits(unitsTempo.filter((i) => [1, 3].includes(i.IdUnit)));

    const addtionalTempo = await getAdditionalCost();
    setAdditional(addtionalTempo?.filter((i) => i.IdStatus === 3706 && i.IdTipo === 1));
    const addtionalTempo2 = await getOtherCost();
    setAdditionalOtros(addtionalTempo2?.filter((i) => i.IdStatus === 3706 && i.IdTipo === 2));


    const yarnTempo = await getYarnTitle();
    setYarn(yarnTempo)

    const dataFabric = await getFabricStyles();
    setFabricStyle(dataFabric)
  
    if(selected?.IdQuotationDetail > 0){
      const addTempo = await getAdditional()

      
      if(costosOtros.length > 0){
        setCostosOtros(costosOtros);
        const totalOtros = costosOtros.reduce((sum, item) => sum + (item.Price || 0), 0);
        setTotalOtros(totalOtros);
      }else{
        const costosOtros1 = addTempo.filter(
          (i) => i.IdTipo === 2 && i.IdQuotationDetail === IdQuotationDetail
        );
        const totalOtros = costosOtros1.reduce((sum, item) => sum + (item.Price || 0), 0);
        setCostosOtros(costosOtros1);
        setTotalOtros(totalOtros);
      }

      if(costosAdicionales.length > 0){
        setCostosAdicionales(costosAdicionales);
        const totalAdicional = costosAdicionales.reduce((sum, item) => sum + (item.Price || 0), 0);
        setTotalAdicional(totalAdicional);
      }else{
        const costosAdicionales1 = addTempo.filter(
          (i) => i.IdTipo === 1 && i.IdQuotationDetail === IdQuotationDetail
        );
        setCostosAdicionales(costosAdicionales1);
        const totalAdicional = costosAdicionales1.reduce((sum, item) => sum + (item.Price || 0), 0);
        setTotalAdicional(totalAdicional);
      }


      setValues({
        ...values,
        IdQuotationDetail: selected?.IdQuotationDetail,
        IdStyleCategory: selected?.IdStyleCategory,
        StyleCategory: selected?.StyleCategory,
        IdYarnTitle: selected?.IdYarnTitle,
        Title: selected?.Title,
        IdYarnTitle2: selected?.IdYarnTitle2,
        Title2: selected?.Title2,
        IdYarnTitle3: selected?.IdYarnTitle3,
        Title3: selected?.Title3,
        IdFabricStyle: selected?.IdFabricStyle,
        FabricStyle: selected?.FabricStyle,
        IdDyeType: selected?.IdDyeType,
        DyeType: selected?.DyeType,
        IdDensity: selected?.IdDensity,
        Density: selected?.Density,
        IdUnit: selected?.IdUnit,
        UnitName: selected?.UnitName,
        Comment: selected?.Comment,
        KnitCost: selected?.KnitCost,
        DyeCost: selected?.DyeCost,
        Cantidad: selected?.Cantidad,
        YarnInt: selected?.YarnInt,
      })
    }else{
      if(selected?.IdQuotationDetail){

        let costosOtros2 = selected?.Adicionales?.filter((i) => i.IdTipo === 2)
        let costosAdicionales2 = selected?.Adicionales?.filter((i) => i.IdTipo === 1)

        setValues({
          ...selected,
          KnitCost: selected?.KnitCost,
          DyeCost: selected?.DyeCost,
        })

        
        setTimeout(() => {          
          setCostosAdicionales(costosAdicionales.length > 0 ? costosAdicionales : costosAdicionales2)
          setCostosOtros(costosOtros.length > 0 ? costosOtros2 : costosOtros2)
          setTotalAdicional(totalAdicional)
          setTotalOtros(totalOtros)
        }, 500);

      }else{
        setCostosAdicionales([])
        setCostosOtros([])
        setTotalOtros(0)
        setTotalAdicional(0)
        setTotal(0)
      }
    }

    setLoading(false);
  };

  const ObtenerDatos = async () => {
    const addtionalTempo = await getAdditionalCost();
    setAdditional(addtionalTempo?.filter((i) => i.IdStatus === 3706 && i.IdTipo === 1));
    const addtionalTempo2 = await getOtherCost();
    setAdditionalOtros(addtionalTempo2?.filter((i) => i.IdStatus === 3706));
  }

  const filtrarHilo = async (IdStyle) => {
    const yarnTempo = await getYarnTitle();
    const filtro = yarnTempo.filter((i) => i.IdStyleCategory === IdStyle);
    if (filtro.length > 0) {
      setYarn(filtro);
    } else {
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con Hilaza disponibles"
      );
      setYarn([]);
    }
  };

  const filtrarTejido = async (IdStyle) => {
    const dataFabric = await getFabricStyles();
    let filtro = dataFabric.filter((i) => i.IdStylesCategory === IdStyle);
    if (filtro.length > 0) {
      setFabricStyle(filtro);
    } else {
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con tejidos disponibles"
      );
      setFabricStyle([]);
    }
  };

  const filtrarDye = async (IdStyle) => {
    const dataDye = await getDyeType();
    let filtro = dataDye.filter((i) => i.IdStylesCategory === IdStyle);
    if (filtro.length > 0) {
      setDyeType(filtro);
    } else {
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con Tipos de colorantes disponibles"
      );
      setDyeType([]);
    }
  };

  const filtrarDensidad = async (IdStyle) => {
    const dataDensity = await getDensity();

    let filtro = dataDensity.filter(
      (i) => i.IdStyleCategory === IdStyle && i.IdStatus === 3706
    );
    if (filtro.length > 0) {
      setDensidad(filtro);
    } else {
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con densidades disponibles"
      );
      setDensidad([]);
    }
  };

  const AgregarCostos = async () => {

    let IdStyleCategory = values.IdStyleCategory ? values.IdStyleCategory : values.StyleCategory?.IdStyleCategory;
    let IdYarnTitle = values?.IdYarnTitle ? values?.IdYarnTitle : values?.Title?.IdYarnTitle;
    let Yarn = values?.YarnInt ? values?.YarnInt : values?.Title?.YarnInt;
    let Yarn2 = values?.YarnInt2 ? values?.YarnInt2 : values?.Title2?.YarnInt;
    let Yarn3 = values?.YarnInt3 ? values?.YarnInt3 : values?.Title3?.YarnInt;
    let PorcentageY1 = values?.PorcentageY1
    let PorcentageY2 = values?.PorcentageY2
    let PorcentageY3 = values?.PorcentageY3



    let IdFabricStyle = values?.IdFabricStyle ? values?.IdFabricStyle : values?.FabricStyle?.IdFabricStyle;
    let IdDyeType = values?.IdDyeType ? values?.IdDyeType : values?.DyeType?.IdDyeType;
    let IdDensity = values?.IdDensity ? values?.IdDensity : values?.Density?.IdDensity;
    let IdUnit = values?.IdUnit ? values?.IdUnit : values?.UnitName?.IdUnit;


    const KnitCostList = await getKnitCost();
    const dyeCostList = await getDyeCost();


    const Yarn1CostItem = KnitCostList.find(
      (item) =>
        item.IdStylesCategory === IdStyleCategory &&
        item.IdFabricStyle === IdFabricStyle &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn >= item.MinYarn && Yarn <= item.MaxYarn))
    );

    const Yarn2CostItem = KnitCostList.find(
      (item) =>
        item.IdStylesCategory === IdStyleCategory &&
        item.IdFabricStyle === IdFabricStyle &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn2 >= item.MinYarn && Yarn2 <= item.MaxYarn))
    );

    
    const Yarn3CostItem = KnitCostList.find(
      (item) =>
        item.IdStylesCategory === IdStyleCategory &&
        item.IdFabricStyle === IdFabricStyle &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn3 >= item.MinYarn && Yarn3 <= item.MaxYarn))
    );

    const PrecioHilo1 = Yarn1CostItem ? (Yarn1CostItem?.Price * (PorcentageY1/100)) : 0
    const PrecioHilo2 = Yarn2CostItem ? (Yarn2CostItem?.Price * (PorcentageY2/100)) : 0
    const PrecioHilo3 = Yarn3CostItem ? (Yarn3CostItem?.Price * (PorcentageY3/100)) : 0

    const nuevoKnitCost = PrecioHilo1 + PrecioHilo2 + PrecioHilo3;

    const dyeCostItem1 = dyeCostList.find(
      (item) =>
        item.IdDyeType === IdDyeType &&
        item.IdDensity === IdDensity &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn >= item.MinYarn && Yarn <= item.MaxYarn))
    );

    const dyeCostItem2 = dyeCostList.find(
      (item) =>
        item.IdDyeType === IdDyeType &&
        item.IdDensity === IdDensity &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn2 >= item.MinYarn && Yarn2 <= item.MaxYarn))
    );

    const dyeCostItem3 = dyeCostList.find(
      (item) =>
        item.IdDyeType === IdDyeType &&
        item.IdDensity === IdDensity &&
        item.IdUnit === IdUnit &&
        (item.MinYarn === null || item.MaxYarn === null || (Yarn3 >= item.MinYarn && Yarn3 <= item.MaxYarn))
    );

    
    const DyePrecioHilo1 = dyeCostItem1 ? (dyeCostItem1?.Price * (PorcentageY1/100)) : 0
    const DyePrecioHilo2 = dyeCostItem2 ? (dyeCostItem2?.Price * (PorcentageY2/100)) : 0
    const DyePrecioHilo3 = dyeCostItem3 ? (dyeCostItem3?.Price * (PorcentageY3/100)) : 0



    const nuevoDyeCost = DyePrecioHilo1 + DyePrecioHilo2 + DyePrecioHilo3;

    setValues((prevValues) => ({
      ...prevValues,
      KnitCost: nuevoKnitCost,
      DyeCost: nuevoDyeCost,
    }));
  };

  const verificarCampos = () => {
    let err = false;

    if (!values?.StyleCategory && !values?.IdStyleCategory) {
      err = true;
      toastShow(toast, "error", "Error", "El estilo de categoría es requerido.");
      return;
    }
    if (!values?.Title && !values?.IdYarnTitle) {
        err = true;
        toastShow(toast, "error", "Error", "El Hilo es requerido.");
        return;
    }
    if (!values?.FabricStyle && !values?.IdFabricStyle) {
        err = true;
        toastShow(toast, "error", "Error", "El estilo de tejido es requerido.");
        return;
    }
    if (!values?.DyeType && !values?.IdDyeType) {
        err = true;
        toastShow(toast, "error", "Error", "El colorante es requerido.");
        return;
    }
    if (!values?.Density && !values?.IdDensity) {
        err = true;
        toastShow(toast, "error", "Error", "La densidad es requerida.");
        return;
    }
    if (!values?.UnitName && !values?.IdUnit) {
        err = true;
        toastShow(toast, "error", "Error", "La unidad es requerida.");
        return;
    }
    if(values?.KnitCost <= 0){
        err = true;
        toastShow(toast, "error", "Error", "No se encontro el costo de tejido seleccionado.");
        return;
    }
    if(values?.DyeCost <= 0){
        err = true;
        toastShow(toast, "error", "Error", "No se encontro el costo de colorante seleccionado.");
        return;
    }

    return !err;
  };

  const asignarValues = () => {
    if(verificarCampos()){

      let Det = costosOtros.filter((detalle) => detalle.Price > 0);
      let Det2 = costosAdicionales.filter((detalle) => detalle.Price > 0);

      if (Det2.length !== costosAdicionales.length) {
        toastShow(toast, "error", "Error", 'Los Precios de los costos Adicionales deben ser mayor a 0.');
        setLoading(false)
        return
      } 
    
      if (Det.length !== costosOtros.length) {
        toastShow(toast, "error", "Error", 'Los Precios de los costos deben ser mayor a 0.');
        setLoading(false)
        return
      } 

      if (values.Cantidad <= 0) {
        toastShow(toast, "error", "Error", 'La cantidad debe ser mayor a 0.');
        setLoading(false)
        return
      } 

      if(values?.PorcentageY1 + values?.PorcentageY2 + values?.PorcentageY3 !== 100 ){
        toastShow(toast, "error", "Error", 'El porcentaje de los hilos debe ser igual a 100%.');
        return
      }

      if(IdQuotation > 0){
        setLoading(true)
        setTimeout(() => {
          agregarNuevaFila(values, true)
          setLoading(false)
          setShowDialog(false)
        }, 800);
      }else{

        setLoading(true)
        setTimeout(() => {
          agregarNuevaFila(values, false)
          setLoading(false)
          setShowDialog(false)
        }, 800);
      }

      // if(selected?.length === 0){//NO EXISTE DETALLE GUARDADO
        // console.log(selected, 'NO EXISTE cotizacion GUARDADO')
        // // let Det = costosOtros.filter((detalle) => detalle.Price > 0);
        // // let Det2 = costosAdicionales.filter((detalle) => detalle.Price > 0);

        // // if (Det2.length !== costosAdicionales.length) {
        // //   toastShow(toast, "error", "Error", 'Los Precios de los costos Adicionales deben ser mayor a 0.');
        // //   setLoading(false)
        // //   return
        // // } 
      
        // // if (Det.length !== costosOtros.length) {
        // //   toastShow(toast, "error", "Error", 'Los Precios de los costos deben ser mayor a 0.');
        // //   setLoading(false)
        // //   return
        // // } 

        // // if (values.Cantidad <= 0) {
        // //   toastShow(toast, "error", "Error", 'La cantidad debe ser mayor a 0.');
        // //   setLoading(false)
        // //   return
        // // } 

        // // setLoading(true)
        // // setTimeout(() => {
        // //   agregarNuevaFila(values)
        // //   setLoading(false)
        // //   setShowDialog(false)
        // // }, 800);

      // }else{ //EXISTE cotizacion GUARDADO IR A GUARDAR AUTOMATICAMENTE
      //   console.log(selected,'EXISTE DETALLE GUARDADO')
      // }

    }
  };

  //------------------- TABLA DE COSTOS ADICIONALES------------------------------

  const agregarCostosAdicional = async () => {
    let newRowData = [...costosAdicionales];
    let IdDet = -(costosAdicionales?.length + 1);
    const newData = {
      IdAdditional: IdDet,
      IdTipo:1,
    };
    // newRowData.push(newData);
    newRowData.push({ ...newData });
    setCostosAdicionales(newRowData);
  };

  const changeAdditionalCost = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={
            Additional.filter(
              (e) => e.IdAdditionalCost === data.IdAdditionalCost
            )[0]
          }
          options={Additional}
          optionLabel="AdditionalCostCont"
          filter
          filterBy="AdditionalCostCont"
          style={{ width: "100%" }}
          onChange={(e) => {
            let newDetail = [...costosAdicionales];
            const index = costosAdicionales.findIndex(
              (detail) => detail.IdAdditionalCost === data.IdAdditionalCost
            );
            newDetail[index].IdAdditionalCost = e.value.IdAdditionalCost;
            newDetail[index].Description = e.value.Description;
            newDetail[index].Price = e.value.Price;
            setCostosAdicionales(newDetail);
            calcularTotalAdicional(newDetail);
          }}
        />
      </div>
    );
  };

  const changeCantidad = ({ data, column }) => {
    const index = costosAdicionales.findIndex(
      (detail) => detail.IdAdditional === data.IdAdditional
    );
    let newDetail = [...costosAdicionales];

    if (column.colDef?.field === "Price") {
      newDetail[index].Price = data.Price;
      setCostosAdicionales(newDetail);
      calcularTotalAdicional(newDetail);
    }
  };

  const calcularTotalAdicional = (newDetail) => {
    const total = newDetail.reduce((acc, item) => acc + parseFloat(item.Price || 0), 0);
    setTotalAdicional(total);
  };

  const columnsAdditionals = [
    {
      field: "IdAdditional",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "Description",
      header: "Descripción",
      headerEn: "Description",
      className: "large",
      flex: 1,
      minWidth: 100,
      editable: ({data}) => data?.IdAdditional ? true : false,
      cellEditor: changeAdditionalCost,
    },
    {
      field: "Price",
      header: "Costo Adicional",
      headerEn: "Additional Cost",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: ({data}) => data?.IdAdditional ? true : false,
      onChange: (data) => changeCantidad(data),
    },
  ];

  const tableAdditionals = {
    Columns: columnsAdditionals,
    Data: costosAdicionales,
    selected: selectedAdd,
    setSelected: setSelectedAdd
  };

  //------------------- TABLA DE OTROS COSTOS ------------------------------

  const agregarCostosOtros = async () => {
    let newRowData = [...costosOtros];
    let IdDet = -(costosOtros?.length + 1);
    const newData = {
      IdAdditional: IdDet,
      Price: 0,
      IdTipo:2,
    };
    // newRowData.push(newData);
    newRowData.push({ ...newData });
    setCostosOtros(newRowData);
  };

  const changeCantidadOtros = ({ data, column }) => {
    const index = costosOtros.findIndex(
      (detail) => detail.IdAdditional === data.IdAdditional
    );
    let newDetail = [...costosOtros];

    if (column.colDef?.field === "Price") {
      newDetail[index].Price = data?.Price;
      setCostosOtros(newDetail);
      calcularTotalOtros(newDetail);
    }
  };

  const changeAdditionalCost2 = ({ data, oldValue, api }, column) => {    
    return (
      <div>
        <Dropdown
          value={
            AdditionalOtros.filter(
              (e) => e.IdAdditionalCost === data.IdAdditionalCost
            )[0]
          }
          options={AdditionalOtros}
          optionLabel="AdditionalCostCont"
          filter
          filterBy="AdditionalCostCont"
          style={{ width: "100%" }}
          onChange={(e) => {
            let newDetail = [...costosOtros];
            const index = costosOtros.findIndex(
              (detail) => detail.IdAdditionalCost === data.IdAdditionalCost
            );
            newDetail[index].IdAdditionalCost = e.value.IdAdditionalCost;
            newDetail[index].Description = e.value.Description;
            newDetail[index].Price = e.value.Price;
            setCostosOtros(newDetail);
            calcularTotalOtros(newDetail);
          }}
        />
      </div>
    );
  };

  const changeDescripcion = ({ data, column }) => {
    const index = costosOtros.findIndex(
      (detail) => detail.IdAdditional === data.IdAdditional
    );
    let newDetail = [...costosOtros];
    if (column.field === "Description") {
      newDetail[index].Description = data.Description;
    }
    setCostosOtros(newDetail);
  };

  const calcularTotalOtros = (newDetail) => {
    const total = newDetail.reduce((acc, item) => acc + parseFloat(item.Price || 0), 0);
    setTotalOtros(total);
  };

  const columnsOthers = [
    {
      field: "IdAdditional",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "IdAdditionalCost",
      header: "",
      headerEn: "",
      className: "XXsmall",
      editable: ({data}) => data?.IdAdditional ? true : false,
      cellEditor: changeAdditionalCost2,
    },
    {
      field: "Description",
      header: "Descripción",
      headerEn: "Description",
      className: "large",
      flex: 1,
      minWidth: 100,
      editable: ({data}) => data?.IdAdditional ? true : false,
      onChange: (data) => changeDescripcion(data),
    },
    {
      field: "Price",
      header: "Otros Costos",
      headerEn: "Others Cost",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: ({data}) => data?.IdAdditional ? true : false,
      onChange: (data) => changeCantidadOtros(data),
    },
  ];

  const tableOthers = {
    Columns: columnsOthers,
    Data: costosOtros,
    selected: selectedOtros,
    setSelected: setSelectedOtros
  };

  const eliminarCost = async (Detalles, tipo) => {
    let apiCalled = false;
    let idsToRemove = Detalles.map((select) => select.IdAdditional);
  
    await Promise.all(
      Detalles.map(async (select) => {
        if (select?.IdAdditional > 0) {
          await EliminarCosto(select);
          apiCalled = true;
        }
      })
    );
  
    if (!apiCalled) {
      if (tipo === 'add') {
        setCostosAdicionales((prev) => prev.filter((item) => !idsToRemove.includes(item.IdAdditional)));
        setSelectedAdd([])
      } else {
        setCostosOtros((prev) => prev.filter((item) => !idsToRemove.includes(item.IdAdditional)));
        setSelectedOtros([])
      }
    }
  
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      toastShow(
        toast,
        "success",
        "Eliminado",
        Detalles.length > 1 ? "Costos eliminados correctamente" : "Costo eliminado correctamente"
      );

      if (apiCalled) {
        getInfo2();
        getInfo(selected);
      }
    }, 850);
  };

  const ejecutarEliminar = (tipo) => {
    const seleccion = tipo === "add" ? selectedAdd : selectedOtros;
    const mensaje = seleccion.length > 1 
      ? `¿Estás seguro de eliminar los ${tipo === "add" ? "costos adicionales" : "costos"}?`
      : `¿Estás seguro de eliminar el ${tipo === "add" ? "costo adicional" : "costo"}?`;
  
    if (seleccion.length <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        `Seleccione al menos un ${tipo === "add" ? "costo adicional" : "costo"}.`
      );
    } else {
      confirmDialog({
        message: mensaje,
        header: "Eliminar Detalle",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          eliminarCost(seleccion, tipo);
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    }
  };
  
  useEffect(() => {
    getInfo2();
  }, []);

  useEffect(() => {
    const IdStyle = values?.IdStyleCategory ? values?.IdStyleCategory : values?.StyleCategory?.IdStyleCategory;

    if (IdStyle) {
      // filtrarHilo(IdStyle);
      // filtrarTejido(IdStyle);
      filtrarDye(IdStyle);
      filtrarDensidad(IdStyle);
      if (values?.StyleCategory?.IdStyleCategory) {
        if (
          !(values?.StyleCategory?.IdStyleCategory === values?.IdStyleCategory)
        ) {
          setValues({
            ...values,
            IdYarnTitle: null,
            Title: "",
            IdFabricStyle: null,
            FabricStyle: "",
            IdDyeType: null,
            DyeType: "",
            IdDensity: null,
            Density: "",
          });
        }
      } else {
        if (!values?.StyleCategory) {
          setValues({
            ...values,
            IdYarnTitle: null,
            Title: "",
            IdFabricStyle: null,
            FabricStyle: "",
            IdDyeType: null,
            DyeType: "",
            IdDensity: null,
            Density: "",
          });
        }
      }
    } else {
      // setYarn([]);
      setValues({
        ...values,
        IdYarnTitle: null,
        Title: "",
        IdFabricStyle: null,
        FabricStyle: "",
        IdDyeType: null,
        DyeType: "",
        IdDensity: null,
        Density: "",
      });
    }
  }, [values?.IdStyleCategory, values?.StyleCategory?.IdStyleCategory]);

  useEffect(() => {
    if(!values?.StyleCategory){
      setValues({
        ...values,
        IdYarnTitle: null,
        Title: "",
        IdYarnTitle2: null,
        Title2: "",
        IdYarnTitle3: null,
        Title3: "",
        IdFabricStyle: null,
        FabricStyle: "",
      });
    }
  }, [values?.StyleCategory]);

  useEffect(() => {
    AgregarCostos();
  }, [
    values.StyleCategory,
    values.Title,
    values.Title2,
    values.Title3,
    values.FabricStyle,
    values.UnitName,
    values.DyeType,
    values.Density,
    values?.PorcentageY1,
    values?.PorcentageY2,
    values?.PorcentageY3,
    values?.KnnittingLoss,
    values?.DyeLoss,
  ]);

  useEffect(() => {
    const IdAdditional = values?.IdAdditionalCost
      ? values?.IdAdditionalCost
      : values?.AdditionalCostCont?.IdAdditionalCost;
    const costoSeleccionado =
      values?.AdditionalCostCont?.Price || values?.AdditionalCost;

    if (IdAdditional) {
      setValues({
        ...values,
        IdAdditional: IdAdditional,
        AdditionalCost: costoSeleccionado,
      });
    } else {
      setValues({
        ...values,
        IdAdditional: null,
        AdditionalCost: null,
      });
    }
  }, [values?.AdditionalCostCont]);

  useEffect(() => {
    if(values?.Cantidad > 0){
      let suma = totalAdicional + totalOtros + values?.KnitCost + values?.DyeCost
      let TOT = suma * values?.Cantidad

      setTotal(TOT)
    }
  }, [totalAdicional, totalOtros, values?.KnitCost, values?.DyeCost, values?.Cantidad]);
  

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => {
          setShowDialog(false);
          setSelected([])
          resetForm();
        }}
      />
      <Button
        label={getLabel(baseLang, "agregar", config.language)}
        icon="pi pi-check"
        className="p-button-text"
        onClick={asignarValues}
        loading={loading}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={showDialog}
      onHide={() => {
        setShowDialog(false)
        setSelected([])
      }}
      closeOnEscape={false}
      footer={DialogFooter}
      header={getLabel(baseLang, "agregarDet", config.language)}
      style={{ width: "85%" }}
    >
      <div id="Dialog">
        {/* <ConfirmDialog /> */}
        <Loader loading={loading} querySelector={"#Dialog"} />
        <Toast ref={toast}></Toast>

        <div className="d-flex">
          <div style={{ width: "100%" }}>

            <div className="d-flex mx-4">
              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StyleCategory"}
                    value={values.StyleCategory}
                    items={styles}
                    field={"StyleCategory"}
                    label={getLabel(baseLang, "estilo", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdStyleCategory ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"FabricStyle"}
                    value={values.FabricStyle}
                    items={fabricStyle}
                    field={"FabricStyle"}
                    label={getLabel(baseLang, "fabric", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdFabricStyle ? "p-invalid" : ""}
                  />
                </span>
              </div>


              {/* HILO 1 */}
              <div className="d-flex">
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Title"}
                      value={values.Title}
                      items={yarn}
                      field={"Title"}
                      label={getLabel(baseLang, "yarn", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdYarnTitle ? "p-invalid" : ""}
                      enable={!(values?.FabricStyle?.YarnQuantity < 1  || !values?.FabricStyle)} 
                    />
                  </span>
                </div>
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <InputNumber
                      name="PorcentageY1"
                      value={values.PorcentageY1}
                      onChange={handleInputChange}
                      suffix=' %'
                      disabled={values?.FabricStyle?.YarnQuantity < 1  || !values?.FabricStyle} 
                    />
                    <label htmlFor="PorcentageY1">{getLabel(baseLang, "PorcentageY1", config.language)}</label>
                  </span>
                </div>
              </div>

              {/* HILO 2 */}
              <div className="d-flex">
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Title2"}
                      value={values.Title2}
                      items={yarn}
                      field={"Title"}
                      label={getLabel(baseLang, "yarn2", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdYarnTitle2 ? "p-invalid" : ""}
                      enable={!(values?.FabricStyle?.YarnQuantity < 2  || !values?.FabricStyle)}
                    />
                  </span>
                </div>
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <InputNumber
                      name="PorcentageY2"
                      value={values.PorcentageY2}
                      suffix=' %'
                      onChange={handleInputChange}
                      disabled={values?.FabricStyle?.YarnQuantity < 2  || !values?.FabricStyle} 
                    />
                    <label htmlFor="PorcentageY2">{getLabel(baseLang, "PorcentageY2", config.language)}</label>
                  </span>
                </div>
              </div>

              {/* HILO 3 */}
              <div className="d-flex">
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Title3"}
                      value={values.Title3}
                      items={yarn}
                      field={"Title"}
                      label={getLabel(baseLang, "yarn3", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdYarnTitle3 ? "p-invalid" : ""}
                      enable={!(values?.FabricStyle?.YarnQuantity < 3  || !values?.FabricStyle)}
                    />
                  </span>
                </div>
                <div className="field me-2 mt-2">
                  <span className="p-float-label">
                    <InputNumber
                      name="PorcentageY3"
                      value={values.PorcentageY3}
                      onChange={handleInputChange}
                      suffix=' %'
                      disabled={values?.FabricStyle?.YarnQuantity < 3 || !values?.FabricStyle} 
                    />
                    <label htmlFor="PorcentageY3">{getLabel(baseLang, "PorcentageY3", config.language)}</label>
                  </span>
                </div>
              </div>



            </div>

            <div className="d-flex mx-4 mt-2">
              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"DyeType"}
                    value={values.DyeType}
                    items={dyeType}
                    field={"DyeType"}
                    label={getLabel(baseLang, "colorante", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdDyeType ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Density"}
                    value={values.Density}
                    items={densidad}
                    field={"Density"}
                    label={getLabel(baseLang, "densidad", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdDensity ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"UnitName"}
                    value={values.UnitName}
                    items={units}
                    field={"UnitName"}
                    label={getLabel(baseLang, "unidad", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdUnit ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="KnnittingLoss"
                    value={values.KnnittingLoss}
                    onChange={handleInputChange}
                    suffix=' %'
                  />
                  <label htmlFor="KnnittingLoss">{getLabel(baseLang, "KnnittingLoss", config.language)}</label>
                </span>
              </div>

              <div className="field me-2 mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="DyeLoss"
                    value={values.DyeLoss}
                    onChange={handleInputChange}
                    suffix=' %'
                  />
                  <label htmlFor="DyeLoss">{getLabel(baseLang, "DyeLoss", config.language)}</label>
                </span>
              </div>

              <div className="d-flex mx-2 mt-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comment"
                    value={values.Comment}
                    onChange={handleInputChange}
                    style={{ height: '4.5vh', width: '100%' }}
                    className={error.Comment ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comment">{getLabel(baseLang, "comentario", config.language)}</label>
                </span>
             </div>
            </div>

          </div>

          {/* <div style={{ width: "15%" }}>
            <div className="d-flex mx-2 mt-2">
              <div className="field col-12">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comment"
                    value={values.Comment}
                    onChange={handleInputChange}
                    style={{ width: "100%", height: '10vh' }}
                    className={error.Comment ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comment">{getLabel(baseLang, "comentario", config.language)}</label>
                </span>
              </div>
            </div>
          </div> */}
        </div>

        <div className="d-flex mx-4 gap-4" style={{ width: "100%" }}>
          <div style={{ width: "48%" }}>
            <Card
              contenido={
                <div className="mb-4" style={{ height: "35vh" }}>
                  <div className="d-flex mx-2">
                    <h5 className="mt-2">{getLabel(baseLang, "costoP", config.language)}</h5>
                    <div className="field">
                      <Button
                        icon="pi pi-plus"
                        type="button"
                        className="mx-4"
                        tooltip="Agregar Costo"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                        onClick={(e) => {
                          ObtenerDatos();
                          agregarCostosAdicional();
                        }}
                        tabIndex={7}
                      />

                      <Button
                        type="button"
                        tooltip="Agregar Costo"
                        icon="pi pi-times"
                        className="p-button-danger listado__botones"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                        onClick={(e) => {
                          ejecutarEliminar('add');
                        }}
                        tabIndex={7}
                      />
                    </div>
                  </div>

                  <div className="mt-2">
                    <div style={{ height: "35vh" }}>
                      <AgGrid table={tableAdditionals} />
                    </div>
                  </div>
                </div>
              }
            />
          </div>

          <div style={{ width: "48%" }}>
            <Card
              contenido={
                <div className="mb-4" style={{ height: "35vh" }}>
                  <div className="d-flex mx-2">
                    <h5 className="mt-2">{getLabel(baseLang, "costoA", config.language)}</h5>
                    <div className="field">
                      <Button
                        icon="pi pi-plus"
                        type="button"
                        className="mx-4"
                        tooltip="Agregar Costo"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                        onClick={(e) => {
                          ObtenerDatos();
                          agregarCostosOtros('costos');
                        }}
                        tabIndex={7}
                      />

                      <Button
                        type="button"
                        tooltip="Agregar Costo"
                        icon="pi pi-times"
                        className="p-button-danger listado__botones"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                        onClick={(e) => {
                          ejecutarEliminar();
                        }}
                        tabIndex={7}
                      />
                    </div>
                  </div>

                  <div className="mt-2">
                    <div style={{ height: "35vh" }}>
                      <AgGrid table={tableOthers} />
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </div>

        <div className="d-flex mt-4 mx-4 mr-4 justify-content-between">

          <div className="gap-2 mx-2">
            <h4>
            {getLabel(baseLang, "costoT", config.language)}: $ {new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(values?.KnitCost)}
            </h4>
            <h4>
            {getLabel(baseLang, "costoC", config.language)}: $ {new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(values?.DyeCost)}
            </h4>
            <h4>
            {getLabel(baseLang, "costoUnit", config.language)}: $ {new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(values?.DyeCost + values?.KnitCost + totalAdicional + totalOtros)}
            </h4>
          </div>


          <div className="justify-content-end gap-2 mt-4">

            <div className="field col-12 mb-4">
              <span className="p-float-label">
                <InputNumber
                  name="Cantidad"
                  value={values.Cantidad}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  minFractionDigits={2} 
                  maxFractionDigits={5}
                />
                <label htmlFor="Cantidad">{getLabel(baseLang, "cantidad", config.language)}</label>
              </span>
            </div>

            <h3>
              Total: $ {new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total)}
            </h3>
          </div>

        </div>



        {dialogKnit && (
          <KnitCostCRUD
            dialog={dialogKnit}
            setDialog={setDialogKnit}
            modo={'Crear'}
          />
        )}

        {dialogDye && (
          <DyeCostCRUD
            dialog={dialogDye}
            setDialog={setDialogDye}
            modo={'Crear'}
          />
        )}

        {dialogAdd && (
          <AdditionalCostCRUD
            dialog={dialogAdd}
            setDialog={setDialogAdd}
            modo={'Crear'}
          />
        )}

        {dialogOther && (
          <OthersCostCRUD
            dialog={dialogOther}
            setDialog={setDialogOther}
            modo={'Crear'}
          />
        )}


      </div>
    </Dialog>
  );
};

export default ModalAgregarDet;
